import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store'
import './interceptor'
import coreui from './plugins/core-ui';
import * as VueGoogleMaps from "vue2-google-maps";
import * as Cookies from 'js-cookie'
import Vue2Filters from 'vue2-filters'
import money from 'v-money'
// Setup locales
import VueI18n from 'vue-i18n'
import messages from './locale'
import { Loading } from 'element-ui';
import './fa-icons'
import roles from '@/directives/roles/index.js'
import permission from '@/directives/permission/index.js'

Vue.config.productionTip = false;
Vue.use(coreui);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDUXBtmvkwlfv-0f8hRwT43Tv9DDS4KLH0", // TODO: change to env
    libraries: "places", // necessary for places input
    installComponents: true
  }
});
Vue.use(Loading.directive);
// register directive v-money and component <money>
Vue.use(money)
Vue.use(Vue2Filters)
Vue.use(VueI18n)
Vue.directive('roles', roles)
Vue.directive('permission', permission)

const i18n = new VueI18n({
  locale: store.getters.getLocale,
  messages
})

let cookie = Cookies.get(process.env.VUE_APP_U4CROWD_COOKIE)
if (cookie) {
  let cookieParse = JSON.parse(cookie)
  axios.defaults.baseURL = cookieParse.host
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
